import theme from '../../../themes/green';

const style = {
  sizes: {
    xs: {
      minWidth: 80,
      height: 20,
      marginLeft: 5,
      marginTop: 5,
      marginRight: 5,
      marginBottom: 5,
    },
    sm: {
      minWidth: 120,
      height: 30,
      marginLeft: 8,
      marginTop: 8,
      marginRight: 8,
      marginBottom: 8,
    },
    md: {
      minWidth: 160,
      height: 40,
    },
    lg: {
      minWidth: 180,
      height: 50,
    },
  },
  base: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 2,
    position: 'relative',
    cursor: 'pointer',
    marginLeft: 10,
    marginTop: 10,
    marginBottom: 10,
    marginRight: 10,
    whiteSpace: 'nowrap',
    transition: 'all 350ms cubic-bezier(0.230, 1.000, 0.320, 1.000)',
    ':hover': {},
  },
  filled: {
    background: theme.pallete.color,
    ':hover': {
      background: theme.pallete.hover,
    },
  },
  outline: {
    border: `2px solid ${theme.pallete.color}`,
    background: 'transparent',
    cursor: 'pointer',
  },
  fullWidth: {
    width: '100%',
  },
  button: {
    position: 'relative',
    padding: 10,
    border: 'none',
    background: 'transparent',
    fontWeight: 600,
    cursor: 'pointer',
    outline: 'none',
    ':hover': {
      outline: 'none',
    },
    ':active': {
      outline: 'none',
    },
    ':focus': {
      outline: 'none',
    },
  },

  buttonSizes: {
    xs: {
      fontSize: 10,
    },
    sm: {
      fontSize: 12,
    },
    md: {
      fontSize: 16,
    },
    lg: {
      fontSize: 18,
    },
  },
  buttonAltText: {
    color: theme.pallete.color,
    transition: 'all 350ms cubic-bezier(0.230, 1.000, 0.320, 1.000)',
    ':hover': {
      color: theme.pallete.hover,
    },
    ':focus': {
      color: theme.pallete.light,
    },
  },
};

export default style;



// WEBPACK FOOTER //
// ./src/components/UIKit/Button/styles.js